<template>
  <div class="owner--connect-header">
    <img :src="bgImage" class="oc--background" />
    <div class="text--container">
      <div class="container">
        <div class="connect-desk">
          <div class="connect-desk--copy">
            <div class="desk--eyebrow">
              {{ isProjectMode ? 'Project Connect' : 'Owner Connect' }}
            </div>
            <div class="oc--subtitle">{{ subtitle }}</div>
            <button type="button" class="btn learn--button" @click="goToHowItWorks">
              <v-icon class="learn--icon">mdi-lightbulb-on-outline</v-icon>
              <span>Pelajari caranya</span>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import HelperMixin from '@/mixins/helpers';

export default {
  name: 'owner-connect-header',
  mixins: [HelperMixin],
  components: {},
  data: () => ({}),
  computed: {
    title() {
      if (
        this.$route.name === 'project-connect' ||
        this.$route.name === 'shortlist-project-connect' ||
        this.$route.name === 'project-connect-cara-kerja'
      ) {
        return this.$t('projectConnect.title');
      }
      return this.$t('ownerConnect.title');
    },
    subtitle() {
      if (
        this.$route.name === 'project-connect' ||
        this.$route.name === 'shortlist-project-connect' ||
        this.$route.name === 'project-connect-cara-kerja'
      ) {
        return this.$t('projectConnect.subtitle');
      }
      return this.$t('ownerConnect.subtitle');
    },
    bgImage() {
      if (
        this.$route.name === 'project-connect' ||
        this.$route.name === 'shortlist-project-connect' ||
        this.$route.name === 'project-connect-cara-kerja'
      ) {
        return 'https://beliruma.b-cdn.net/public/static/img/project-connect/background-oc.png';
      }
      return 'https://beliruma.b-cdn.net/public/static/img/owner-connect/background-oc.png';
    },
    isProjectMode() {
      return (
        this.$route.name === 'project-connect' ||
        this.$route.name === 'shortlist-project-connect' ||
        this.$route.name === 'project-connect-cara-kerja'
      );
    },
  },
  watch: {},
  mounted() {},
  methods: {
    goToHowItWorks() {
      this.$router.push({
        name: this.isProjectMode ? 'project-connect-cara-kerja' : 'owner-connect-cara-kerja',
      });
    },
  },
};
</script>

<style scoped lang="scss">
@import '@/assets/scss/utils/variables';

.owner--connect-header {
  position: relative;
  overflow: hidden;
  isolation: isolate;
  height: 360px;

  &::after {
    content: '';
    position: absolute;
    inset: 0;
    z-index: 1;
    background: linear-gradient(
      90deg,
      rgba(18, 18, 18, 0.72),
      rgba(18, 18, 18, 0.28) 52%,
      rgba(18, 18, 18, 0.1)
    );
    pointer-events: none;
  }

  @media #{$tablets} {
    height: 320px;
  }

  @media #{$phones} {
    height: 280px;
  }
}

.oc--background {
  height: 360px;
  filter: saturate(0.9) contrast(1.02);
  transform: scale(1.01);

  @media #{$tablets} {
    height: 320px;
  }

  @media #{$phones} {
    height: 280px;
  }
}

.text--container {
  position: relative;
  z-index: 2;
  bottom: auto;
  top: 50%;
  transform: translateY(-50%);
  background-image: none;
  padding: 0;
}

.connect-desk {
  max-width: 720px;
  padding: 0;
}

.connect-desk--copy {
  position: relative;
  padding-left: 0;
}

.desk--eyebrow {
  display: inline-flex;
  align-items: center;
  min-height: 34px;
  padding: 0 14px;
  border-radius: 999px;
  background: rgba(255, 255, 255, 0.96);
  color: #171717;
  font-family: Poppins-Bold, sans-serif;
  font-size: 12px;
  box-shadow: 0 12px 26px rgba(0, 0, 0, 0.16);
  margin-bottom: 12px;
}

:deep(.oc--title) {
  max-width: 820px;
  font-family: Poppins-Bold, sans-serif;
  letter-spacing: 0;
}

:deep(.oc--subtitle) {
  max-width: 760px;
  color: rgba(255, 255, 255, 0.88);
  line-height: 1.55;
}

.learn--button {
  display: inline-flex;
  align-items: center;
  min-height: 42px;
  margin-top: 18px;
  padding: 0 20px;
  border: 1px solid rgba(255, 255, 255, 0.58);
  border-radius: 999px;
  background: $color-beliruma-1;
  color: $color-white;
  font-family: Poppins-Bold, sans-serif;
  font-size: 14px;
  box-shadow: 0 14px 30px rgba(0, 0, 0, 0.2);

  .learn--icon {
    color: $color-white;
    font-size: 19px;
  }

  &:hover,
  &:focus {
    background: $color-white;
    color: #d5121b;

    .learn--icon {
      color: #d5121b;
    }
  }

  @media #{$phones} {
    width: 100%;
    justify-content: center;
  }
}
</style>
